import { Component, Mixins } from 'vue-property-decorator'
import {updateItems} from '@/lib'
import {IServiceType} from '@/entities'
import onLocaleChangeMixin from '@/mixins/onLocaleChangeMixin'

@Component
class fetchServiceTypeMixin extends Mixins(onLocaleChangeMixin) {

  protected initFetches: Function[] = [
    this.fetchServiceTypes
  ];

  protected reFetches = [
    this.updateServiceTypes
  ];

  protected fetching: boolean = false;
  protected services: IServiceType[] = [];

  private fetchServiceTypes(): void {
    this.fetching = true;
    this.$storage.actions.fetchServiceTypes()
      .then(res => {
        this.services = res;
      })
      .catch(() => {})
      .finally(() => {
        this.fetching = false;
      });
  }

  private updateServiceTypes(): void {
    updateItems(this.services, this.$storage.actions.getServiceTypeById);
  }

}

export default fetchServiceTypeMixin
